<template>
  <v-card class="px-2 py-4">
    <v-card-title class="text-h6 darken--text px-2 py-0 align-start">
      Oczekujące na akceptacje
      <div>
        <v-btn
          class="carousel-nav-button"
          outlined
          :disabled="projects.length <= carouselColumns"
          @click="changeSlide('prev')"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn
          class="carousel-nav-button ml-2"
          outlined
          :disabled="projects.length <= carouselColumns"
          @click="changeSlide('next')"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </v-card-title>
    <carousel
      v-model="currentSlide"
      :loop="true"
      :per-page="carouselColumns"
      :scroll-per-page="false"
      :pagination-enabled="false"
    >
      <slide
        v-for="(project, index) in projects"
        :key="'project' + project.id"
        @slideclick="$emit('changeProject', {index})"
      >
        <AwaitingProjectCard :project="project" />
      </slide>
    </carousel>
  </v-card>
</template>

<script>
import AwaitingProjectCard from '@/components/Projects/Acceptance/AwaitingProjectCard.vue';
import { Carousel, Slide } from 'vue-carousel';
import utils from '@/helpers/utils';

export default {
  components: {
    AwaitingProjectCard,
    Carousel,
    Slide,
  },
  props: {
    projects: {
      type: Array,
      required: true,
    },
  },

  data: () => ({
    currentSlide: 0,
  }),
  computed: {
    carouselColumns() {
      return utils.getResponsiveValues.call(this, 5, 4, 3, 2, 1);
    },
  },
  methods: {
    changeSlide(dir) {
      if (dir === 'next') {
        if (this.currentSlide + this.carouselColumns === this.projects.length) {
          this.currentSlide = 0;
        } else {
          this.currentSlide += 1;
        }
      } else if (dir === 'prev') {
        if (this.currentSlide === 0) {
          this.currentSlide = this.projects.length - this.carouselColumns;
        } else {
          this.currentSlide -= 1;
        }
      }
    },
  },
};
</script>
